// extracted by mini-css-extract-plugin
export default {"BlankslateContainer":"Blankslate-module__BlankslateContainer--RzN0V"};